import Debug from "debug";

const debug = Debug("cs.SessionInstanceState");

// Stores individual pieces of state in memory to persist them across resizes,
// where the session components are recreated from scratch.
export default abstract class SessionInstanceState {
  public static data: any = {};

  public static withStore<T>(key: string, initialValue: T): T {
    if (this.has(key)) {
      debug(`withStore, key '${key}', using store`, {
        initialValue,
        valueFromStore: this.data[key],
      });
      return this.data[key];
    }
    debug(`withStore, key '${key}', using initial value`, initialValue);
    this.data[key] = initialValue;
    return initialValue;
  }

  public static set<T>(key: string, value: T): void {
    debug(`set, key '${key}`, value);
    this.data[key] = value;
  }

  public static get<T>(key: string): T {
    return this.data[key];
  }

  public static has(key: string): boolean {
    return Object.prototype.hasOwnProperty.call(this.data, key);
  }
}
